import { Navigate, useSearchParams } from 'react-router';
import { HorizontalContainer, VerticalContainer } from '@/components';
import { GreenDotIcon, RedDotIcon } from '@/components/Icons';
import type { TrainingProgramViewModel } from '@/features/profile/model/types';
import { R } from '@/features/profile/resources/ProfileResources.resx';

type TrainingProgramDetailsProps = {
    trainingPrograms: TrainingProgramViewModel[];
};

export const TrainingProgramDetails = ({
    trainingPrograms,
}: TrainingProgramDetailsProps) => {
    const [searchParams] = useSearchParams();
    const program = trainingPrograms.find(
        (item) => String(item.UserId) === searchParams.get('userId'),
    );

    if (!program) {
        return <Navigate to="/Access" replace />;
    }

    return (
        <VerticalContainer spacing="md" className="w-full">
            <HorizontalContainer spacing="xs" className="items-center text-sm">
                {program.IsActive && <GreenDotIcon className="size-2" />}
                {!program.IsActive && <RedDotIcon className="size-2" />}
                <span>{program.StatusText}</span>
            </HorizontalContainer>

            <VerticalContainer spacing="sm">
                <h2 id="heading-TrainingProgramDetails">
                    {R.TrainingProgram_Title}
                </h2>
                <div className="text-lg text-(--color-text-secondary)">
                    {R.IssuedTo}: {program.Name}
                </div>
                <div className="text-(--color-text-secondary)">
                    {R.TrainingProgram_ValidUntil}
                    {program.ExpirationDateString}
                    {program.IsActive && (
                        <>
                            <br /> {R.TrainingProgram_RenewalDetails}
                        </>
                    )}
                </div>
            </VerticalContainer>

            <HorizontalContainer spacing="sm">
                <img
                    className="self-center"
                    width="24"
                    height="24"
                    src="/images/icons/check-orange.svg"
                    alt=""
                />
                <span className="leading-normal">
                    {R.TrainingProgram_PersonalProgram}
                </span>
            </HorizontalContainer>
        </VerticalContainer>
    );
};
